const marketingCenter = () => import('@/view/marketingCenter/index')
const memberLevel = () => import('@/view/marketingCenter/memberLevel')
const coupon = () => import('@/view/marketingCenter/coupon')
const crowdMarketing = () => import('@/view/marketingCenter/crowdMarketing')
const sceneMarketing = () => import('@/view/marketingCenter/sceneMarketing')
const crowdDetails = () => import('@/view/marketingCenter/crowdDetails')
const changeRecord = () => import('@/view/marketingCenter/changeRecord')
const dataReport = () => import('@/view/marketingCenter/dataReport')
const newCoupons = () => import('@/view/marketingCenter/newCoupons')
const newMarketingPlan = () => import('@/view/marketingCenter/newMarketingPlan')
const newMemberLevel = () => import('@/view/marketingCenter/newMemberLevel')
const newScenarioPlan = () => import('@/view/marketingCenter/newScenarioPlan')
const couponDetails = () => import('@/view/marketingCenter/couponDetails')
const sceneDetails = () => import('@/view/marketingCenter/sceneDetails')
const scenarioReport = () => import('@/view/marketingCenter/scenarioReport')
let router = [
    {
      path: '/marketingCenter',
      component: marketingCenter,
      name: 'marketingCenter',
      redirect:"/marketingCenter/memberlist",
      meta: {
        menuTitle: "营销中台",
        menuKey: "marketingCenter",
        menuIcon: "icon-interaction",
      },
      children:[
        {
          path:'marketingApplication',
          component:marketingCenter,
          name:"marketingApplication",
          redirect:"/marketingCenter/memberLevel",
          meta:{
            menuKey:"marketingCenter",
            menuTitle: "营销应用",
            menuIcon: "icon-Marketing-Application",
          },
          children:[
            {
                path:"/marketingCenter/memberLevel",
                component:memberLevel,
                name:'memberLevel',
                meta:{
                  menuKey:"marketingCenter",
                  menuTitle: "会员等级",
                  menuIcon: "el-icon-chat-dot-round",
                }
            },
            {
              path:"/marketingCenter/changeRecord",
              component:changeRecord,
              name:'changeRecord',
              meta:{
                menuKey:"marketingCenter",
                secondMenuKey: 'memberLevel'
              }
            },
            {
              path:"/marketingCenter/newMemberLevel",
              component:newMemberLevel,
              name:'newMemberLevel',
              meta:{
                menuKey:"marketingCenter",
                secondMenuKey: 'memberLevel'
              }
            },
            {
                path:"/marketingCenter/coupon",
                component:coupon,
                name:'coupon',
                meta:{
                  menuKey:"marketingCenter",
                  menuTitle: "优惠券",
                  menuIcon: "el-icon-chat-dot-round",
                }
            },
            {
              path:"/marketingCenter/newCoupons",
              component:newCoupons,
              name:'newCoupons',
              meta:{
                menuKey:"marketingCenter",
                secondMenuKey: 'coupon'
              }
            },
            {
              path:"/marketingCenter/couponDetails",
              component:couponDetails,
              name:'couponDetails',
              meta:{
                menuKey:"marketingCenter",
                secondMenuKey: 'coupon'
              }
            },
          ]
        },
        {
          path:'MemberPortrait',
          component:marketingCenter,
          name:"MemberPortrait",
          meta:{
            menuKey:"marketingCenter",
            menuTitle: "智能营销",
            menuIcon: "icon-Intelligent-marketing",
          },
          children:[
            {
                path:"/marketingCenter/crowdMarketing",
                component:crowdMarketing,
                name:'crowdMarketing',
                meta:{
                  menuKey:"marketingCenter",
                  menuTitle: "人群营销",
                  menuIcon: "icon-Marketing-Application",
                }
            },
            {
              path:"/marketingCenter/crowdDetails",
              component:crowdDetails,
              name:'crowdDetails',
              meta:{
                menuKey:"marketingCenter",
                secondMenuKey: 'crowdMarketing'
              }
            },
            {
              path:"/marketingCenter/dataReport",
              component:dataReport,
              name:'dataReport',
              meta:{
                menuKey:"marketingCenter",
                secondMenuKey: 'crowdMarketing'
              }
            },
            {
              path:"/marketingCenter/crowdDetails",
              component:crowdDetails,
              name:'crowdDetails',
              meta:{
                menuKey:"marketingCenter",
                secondMenuKey: 'crowdMarketing'
              }
            },
            {
              path:"/marketingCenter/newMarketingPlan",
              component:newMarketingPlan,
              name:'newMarketingPlan',
              meta:{
                menuKey:"marketingCenter",
                secondMenuKey: 'crowdMarketing'
              }
            },
            {
                path:"/marketingCenter/sceneMarketing",
                component:sceneMarketing,
                name:'sceneMarketing',
                meta:{
                  menuKey:"marketingCenter",
                  menuTitle: "场景营销",
                  menuIcon: "el-icon-chat-dot-round",
                }
            },
            {
              path:"/marketingCenter/newScenarioPlan",
              component:newScenarioPlan,
              name:'newScenarioPlan',
              meta:{
                menuKey:"marketingCenter",
                secondMenuKey: 'sceneMarketing'
              }
            },
            {
              path:"/marketingCenter/scenarioReport",
              component:scenarioReport,
              name:'scenarioReport',
              meta:{
                menuKey:"marketingCenter",
                secondMenuKey: 'sceneMarketing'
              }
            },
            {
              path:"/marketingCenter/sceneDetails",
              component:sceneDetails,
              name:'sceneDetails',
              meta:{
                menuKey:"marketingCenter",
                secondMenuKey: 'sceneMarketing'
              }
            },
          ]
        },
      ]
    }
  ]
  export default router